import Storage from './Storage';
import Utilities from './Utilities';
import SQLStorageImported from './SQLStorage';
import { create, language } from 'ionicons/icons';

class SQLStorage {

    static async updateLinksReturnStudysetId(cardId, linkedCardId, operation) {

        if (window.useIndexedDb) {

            let cards = await window.db.cards.where("id").equals(linkedCardId).toArray();

            if (cards.length !== 0) {
                let card = cards[0];
                let links = card.links && card.links !== "" && card.links !== undefined && card.links !== null ? card.links.split("£££") : [];

                if (operation === "add") {
                    links.push(cardId);
                } else {
                    links.splice(links.indexOf(cardId), 1);
                }

                card.links = links.join("£££");
                card.updatedAt = Utilities.formatDate(Utilities.iOSFixDate(new Date()), "YYYY-MM-DD HH:MM:SS.SSS")
                card.updatedAtTimestamp = Utilities.timestamp();
                let dRes = await window.db.cards.where("id").equals(linkedCardId).delete();
                let iRes = await window.db.cards.put(card);
                console.log(dRes, iRes);

                return card.setId;
            }

            return null;
        } else {
            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT setId, links FROM Cards WHERE id="' + linkedCardId + '"', [], async function(tx, rs) {
                        if (rs.rows.length > 0) {
                            let card = rs.rows.item(0);
                            let links = card.links && card.links !== "" && card.links !== undefined && card.links !== null ? card.links.split("£££") : [];

                            if (operation === "add") {
                                links.push(cardId);
                            } else {
                                links.splice(links.indexOf(cardId), 1);
                            }

                            tx.executeSql(`
                                UPDATE Cards
                                Set 
                                    links=?,
                                    updatedAt=?, 
                                    updatedAtTimestamp=?
                                WHERE id=?
                            `, [
                                links.join("£££"), 
                                Utilities.formatDate(Utilities.iOSFixDate(new Date()), "YYYY-MM-DD HH:MM:SS.SSS"),
                                Utilities.timestamp(),
                                linkedCardId
                            ], function(tx, rs) {
                                resolve(card.setId)
                            }, function(tx, error) { console.log(error); resolve([]) });

                            await window.dropbox.queueForUpload("card", linkedCardId + "-" + card.setId);

                        } else {
                            resolve(null)
                        }
                    }, function(tx, error) { console.error(error); resolve(null) });
                });

            })
        }

    }

    static async saveCard(card, noModification, noReview, oldLinks) {

        let cards = (!Array.isArray(card)) ? [card] : card;
        const idsArr = cards.map(item => item.id);

        if (window.useIndexedDb) {

            let cRes = await window.db.cards.where("id").anyOf(idsArr).delete();
            let tiRes = await window.db.tagIndexes.where("cardId").anyOf(idsArr).delete();
            let tagIndexes = [];
            let preparedCards = [];

            for (let i = 0; i < cards.length; i++) {

                card = Utilities.prepareCardForDb(cards[i], noModification, noReview);

                if (card.deleted !== "t") {

                    if (card.tags && card.tags.length > 0) {
                        for (let i = 0; i < card.tags.length; i++) {
                            let tagId = card.tags[i];
                            tagIndexes.push([card.setId, card.id, tagId])
                        }
                    }

                    card.createdAt = card.createdAtFormatted;
                    card.updatedAt = card.updatedAtFormatted;
                    card.tags = card.tags.join(",")
                    delete card.notYetSaved;
                    delete card.editing;

                    preparedCards.push(card)

                    if (card.star) tagIndexes.push([card.setId, card.id, 'star'])
                    if (card.strength === 1) tagIndexes.push([card.setId, card.id, 'studying'])
                    else if (card.strength === 3) tagIndexes.push([card.setId, card.id, 'learnt'])
                    else if (card.strength === 5) tagIndexes.push([card.setId, card.id, 'mastered'])
                    else tagIndexes.push([card.setId, card.id, 'new'])
                    if (card.image) tagIndexes.push([card.setId, card.id, 'image'])

                } else {
                    preparedCards.push({
                        id: card.id,
                        deleted: "t",
                        updatedAtTimestamp: card.updatedAtTimestamp
                    })
                }
                
            }

            const ids = await window.db.cards.bulkPut(preparedCards);

            if (tagIndexes.length !== 0) {
                let res = await window.db.tagIndexes.bulkPut(tagIndexes.map(item => {
                    return {
                        setId: item[0],
                        cardId: item[1],
                        tagId: item[2]
                    }
                }));
                console.log(res)
            }

            if (oldLinks) {
                let currentLinks = JSON.parse(JSON.stringify(cards[0].links));
                let newLinks = currentLinks.filter(i => oldLinks.indexOf(i) === -1);
                let deletedLinks = oldLinks.filter(i => currentLinks.indexOf(i) === -1);
                let updatedSetIds = [];
                
                for (let i = 0; i < newLinks.length; i++) {
                    let setId = await SQLStorageImported.updateLinksReturnStudysetId(cards[0].id, newLinks[i], "add");
                    updatedSetIds.push(setId)
                }

                for (let i = 0; i < deletedLinks.length; i++) {
                    let setId = await SQLStorageImported.updateLinksReturnStudysetId(cards[0].id, deletedLinks[i], "delete");
                    updatedSetIds.push(setId)
                }

                updatedSetIds = [...new Set(updatedSetIds)];

            }

        } else {

            return new Promise(async function(resolve, reject) {

                const ids = idsArr.join('","');

                window.db.transaction(async function(tx) {

                    tx.executeSql('DELETE FROM Cards WHERE id IN ("' + ids + '")', []);
                    tx.executeSql('DELETE FROM TagIndexes WHERE cardId IN ("' + ids + '")', []);
                    let tagIndexes = [];

                    for (let i = 0; i < cards.length; i++) {

                        card = Utilities.prepareCardForDb(cards[i], noModification, noReview);
        
                        if (card.deleted !== "t") {

                            // window.toast("INserted " + Utilities.formatDate(new Date(card.lastReviewed*1000), "DDd HHh"));
        
                            tx.executeSql('INSERT INTO Cards (id, createdAt, updatedAt, term, definition, tags, setId, star, history, strength, strengthUpdatedAt, tagUpdatedAt, starUpdatedAt, lastReviewed, reviewCount, mistakeLastMade, mistakeCount, successLastMade, successCount, reviewAfter, revisionCycle, image, updatedAtTimestamp, customText1, customInt1, customText2, links) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)', [
                                card.id, 
                                card.createdAtFormatted, 
                                card.updatedAtFormatted, 
                                card.term, 
                                card.definition, 
                                card.tags.join(","), 
                                card.setId, 
                                card.star,
                                card.history,
                                card.strength,
                                card.strengthUpdatedAt,
                                card.tagUpdatedAt,
                                card.starUpdatedAt,
                                card.lastReviewed,
                                card.reviewCount,
                                card.mistakeLastMade,
                                card.mistakeCount,
                                card.successLastMade,
                                card.successCount,
                                card.reviewAfter,
                                card.revisionCycle,
                                card.image || "",
                                card.updatedAtTimestamp,
                                card.customText1 || "",
                                card.customInt1 || null,
                                card.customText2 || "",
                                card.links || ""
                            ]);
        
                            if (card.tags && card.tags.length > 0) {
                                for (let i = 0; i < card.tags.length; i++) {
                                    let tagId = card.tags[i];
                                    tagIndexes.push([card.setId, card.id, tagId])
                                }
                            }
        
                            if (card.star) tagIndexes.push([card.setId, card.id, 'star'])
                            if (card.strength === 1) tagIndexes.push([card.setId, card.id, 'studying'])
                            else if (card.strength === 3) tagIndexes.push([card.setId, card.id, 'learnt'])
                            else if (card.strength === 5) tagIndexes.push([card.setId, card.id, 'mastered'])
                            else tagIndexes.push([card.setId, card.id, 'new'])
                            if (card.image) tagIndexes.push([card.setId, card.id, 'image'])
        
                        } else {
                            tx.executeSql('INSERT INTO Cards (id, updatedAtTimestamp, deleted) VALUES (?,?,"t")', [card.id, card.updatedAtTimestamp])
                        }
                        
                    }

                    if (tagIndexes.length !== 0) {
                        let SQL = 'INSERT INTO TagIndexes VALUES ' + tagIndexes.map(item => `("${item[0]}","${item[1]}","${item[2]}")`);
                        tx.executeSql(SQL)
                    }

                    if (oldLinks) {
                        let currentLinks = JSON.parse(JSON.stringify(cards[0].links));
                        let newLinks = currentLinks.filter(i => oldLinks.indexOf(i) === -1);
                        let deletedLinks = oldLinks.filter(i => currentLinks.indexOf(i) === -1);
                        let updatedSetIds = [];
                        
                        for (let i = 0; i < newLinks.length; i++) {
                            let setId = await SQLStorageImported.updateLinksReturnStudysetId(cards[0].id, newLinks[i], "add");
                            updatedSetIds.push(setId)
                        }

                        for (let i = 0; i < deletedLinks.length; i++) {
                            let setId = await SQLStorageImported.updateLinksReturnStudysetId(cards[0].id, deletedLinks[i], "delete");
                            updatedSetIds.push(setId)
                        }

                        updatedSetIds = [...new Set(updatedSetIds)];

                    }

                }, function(error) { console.log("FAILED TO SAVE CARD", error); resolve() }, function() { resolve(); });

            })

        }

    }

    static async saveSet(set) {

        console.log("@@@@ saveSet", set)

        let createdAtFormatted = Utilities.formatDate(Utilities.iOSFixDate(set.createdAt), "YYYY-MM-DD HH:MM:SS.SSS");
        let updatedAtFormatted = Utilities.formatDate(Utilities.iOSFixDate(set.updatedAt), "YYYY-MM-DD HH:MM:SS.SSS");

        if (window.useIndexedDb) {
            set.createdAt = createdAtFormatted;
            set.updatedAt = updatedAtFormatted;
            let id = await window.db.sets.put(set);
            return id;
        } else {

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql('DELETE FROM Sets WHERE id=$1', [set.id]);
                    tx.executeSql('INSERT INTO Sets (id, createdAt, updatedAt, name, term, definition, viewSecret, editSecret, lastPushed, lastFetched, shareMode, owner, description, ownerUsername, ownerImageUrl) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)', [set.id, createdAtFormatted, updatedAtFormatted, set.name, set.term, set.definition, set.viewSecret || "", set.editSecret || "", set.lastPushed || "", set.lastFetched || "", set.shareMode || "", set.owner || "", set.description || "", set.ownerUsername || "", set.ownerImageUrl || ""]);
                }, function(error) { console.log(error); resolve() }, function() { resolve(); });
            })

        }

    }

    static async saveBatchContent(batches) {

        // console.log("@@@@ saveBatchContent")

        if (window.useIndexedDb) {
            let res = await window.db.batchContent.bulkPut(batches.map(item => {
                return {
                    batchTimestamp: item[0],
                    cardId: item[1]
                }
            }));
            return res;
        } else {

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    for (let i = 0; i < batches.length; i++) {
                        const element = batches[i];
                        tx.executeSql('DELETE FROM BatchContent WHERE batchTimestamp=' + element[0] + ' AND cardId="' + element[1] + '"' , []);
                        tx.executeSql('INSERT INTO BatchContent (batchTimestamp, cardId) VALUES (?,?)', [element[0], element[1]]);
                    }
                }, function(error) { console.log(error); resolve() }, function() { resolve(); });
            })

        }

    }

    static async saveTag(tag) {

        // console.log("@@@@ saveTag")

        let createdAtFormatted = Utilities.formatDate(Utilities.iOSFixDate(tag.createdAt), "YYYY-MM-DD HH:MM:SS.SSS");
        let updatedAtFormatted = Utilities.formatDate(Utilities.iOSFixDate(tag.updatedAt), "YYYY-MM-DD HH:MM:SS.SSS");

        if (window.useIndexedDb) {
            tag.updatedAt = updatedAtFormatted;
            tag.createdAt = createdAtFormatted;
            const id = await window.db.tags.put(tag);
            return id;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('DELETE FROM Tags WHERE id=$1', [tag.id]);
                    tx.executeSql('INSERT INTO Tags (id, createdAt, updatedAt, name, color) VALUES (?,?,?,?,?)', [tag.id, createdAtFormatted, updatedAtFormatted, tag.name, tag.color]);
                }, function(error) { console.log(error); resolve() }, function() { resolve(); });

            })

        }

    }

    static async deleteTag(id) {

        // console.log("@@@@ deleteTag")

        if (window.useIndexedDb) {
            const dId = await window.db.tags.where("id").equals(id).delete();
            return dId;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('DELETE FROM Tags WHERE id=$1', [id]);
                }, function(error) { console.log(error); resolve() }, function() { resolve(); });

            })

        }

    }

    static async deleteCard(id) {

        // console.log("@@@@ deleteCard")

        let ids = id;

        if (typeof id !== "object") {
            ids = [id];
        }

        if (window.useIndexedDb) {
            const dId = await window.db.cards.where("id").anyOf(ids).delete();
            return dId;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('DELETE FROM Cards WHERE id IN ("' + ids.join('","') + '")', []);
                }, function(error) { console.log(error); resolve() }, function() { resolve(); });

            })

        }

    }

    static async getAndDeleteCardsWithoutSets() {
        if (window.useIndexedDb) {
            const sets = await window.db.sets.toArray();
            const setIds = sets.map(set => set.id);
            const deletedSetCards = await window.db.cards.where("setId").noneOf(setIds).toArray();
            if (deletedSetCards.length === 0) {
                return 0;
            } else {
                const deletedSetCardsDelete = await window.db.cards.where("setId").noneOf(setIds).delete();
                return deletedSetCards;
            }
        } else {
            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Cards WHERE setId NOT IN (SELECT id FROM Sets)', [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            cards.push(Utilities.prepareCardFromDb(rs.rows.item(i)))
                        }
                        tx.executeSql('DELETE FROM Cards WHERE setId NOT IN (SELECT id FROM Sets)', [], function(tx, rs) {
                            resolve(cards)
                        }, function(tx, error) { console.error(error); resolve([]) });
                    }, function(tx, error) { console.error(error); resolve([]) });
                });
            })
        }

    }

    static async deleteSet(id) {

        // console.log("@@@@ deleteSet")

        if (window.useIndexedDb) {
            const dIds = await window.db.cards.where("setId").equals(id).delete();
            const dId = await window.db.sets.where("id").equals(id).delete();
            return dId;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('DELETE FROM Sets WHERE id=$1', [id]);
                    tx.executeSql('DELETE FROM Cards WHERE "setId"=$1', [id]);
                }, function(error) { console.log(error); resolve() }, function() { resolve(); });

            })

        }

    }

    static async getCardsBetweenReviewed(start, end) {

        // console.log("@@@@ getCardsBetweenReviewed")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.where("lastReviewed").between(start, end).filter(card => card.customInt1 === "").toArray()
            cards = cards.map(Utilities.prepareCardFromDb);
            return cards || []
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT history,id FROM Cards WHERE CustomInt1 IS NULL AND lastReviewed BETWEEN ' + parseInt(start) + ' AND ' + parseInt(end), [], function(tx, rs) {
                        let cards = []
                        for (var i = 0; i < rs.rows.length; i++) {
                            let card = rs.rows.item(i);
                            if (card.history) card.history = JSON.parse(card.history); else card.history = [];
                            cards.push(card)
                        }
                        resolve(cards)
                    }, function(tx, error) { console.error(error); resolve(null) });
                });

            })

        }

    }

    static async getCardById(id) {

        // console.log("@@@@ getCardById")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.where("id").equals(id).toArray();
            return cards.length !== 0 ? Utilities.prepareCardFromDb(cards[0]) : null;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Cards WHERE id="' + id + '"', [], function(tx, rs) {
                        if (rs.rows.length > 0) {
                            resolve(Utilities.prepareCardFromDb(rs.rows.item(0)))
                        }
                    }, function(tx, error) { console.error(error); resolve(null) });
                });

            })

        }

    }

    static async getAllCardsLastReviewed() {

        return new Promise(async function(resolve, reject) {

            window.db.transaction(function(tx) {
                tx.executeSql('SELECT * FROM Cards ORDER by lastReviewed DESC LIMIT 50', [], function(tx, rs) {
                    let cards = [];
                    for (var i = 0; i < rs.rows.length; i++) {
                        cards.push(Utilities.prepareCardFromDb(rs.rows.item(i)))
                    }
                    resolve(cards)
                }, function(tx, error) { console.error(error); resolve([]) });
            });

        })

    }

    static async getAllCardIds() {

        if (window.useIndexedDb) {
            let cards = await window.db.cards.toArray().map(card => card.id);
            return cards || [];
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT Id FROM Cards', [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            cards.push(rs.rows.item(i).id)
                        }
                        resolve(cards)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getAllCardsFromStudyset(id, orderBy, direction) {

        console.log("@@@@ getAllCardsFromStudyset " + id + " " + orderBy + " " + direction)

        if (window.useIndexedDb) {
            let FILTER = {
                customInt1: ""
            }
            if (id) {
                FILTER.setId = id
            }
            let cards = await window.db.cards.where(FILTER).toArray();
            cards = cards.map(Utilities.prepareCardFromDb);

            if (orderBy === "term" || orderBy === "definition") {
                cards.sort((a, b) => { return (a[orderBy].localeCompare(b[orderBy])) })
            } else {
                cards.sort((a, b) => { return (a[orderBy] - b[orderBy]) })
                if (orderBy === "lastReviewed") {
                    cards.sort((a, b) => { return (a['strength'] - b['strength']) })
                }
            }

            if (direction === "DESC") {
                cards.reverse();   
            }
            return cards || [];
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Cards WHERE (CustomInt1 IS NULL ' + (id ? ' AND setId="' + id + '"' : '') + ') ORDER BY ' + orderBy + " " + direction + (orderBy === "lastReviewed" ? ", strength ASC" : ""), [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            cards.push(Utilities.prepareCardFromDb(rs.rows.item(i)))
                        }
                        resolve(cards)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getAllArchivedCards() {

        // console.log("@@@@ getAllArchivedCards")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.where("customInt1").notEqual("").toArray();
            cards = cards.map(Utilities.prepareCardFromDb);
            return cards;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Cards WHERE CustomInt1 IS NOT NULL', [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            let card = Utilities.prepareCardFromDb(rs.rows.item(i));
                            cards.push(card)
                        }
                        resolve(cards)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getCardsByIds(cardIds, returnArray) {

        // console.log("@@@@ getCardsByIds")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.where("id").anyOf(cardIds).toArray();
            cards = cards.map(Utilities.prepareCardFromDb);
            if (returnArray) {
                return cards;
            } else {
                let cardsObj = {};
                for (let i = 0; i < cards.length; i++) {
                    cardsObj[cards[i].id] = cards[i];
                }
                return cardsObj
            }
        } else {

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * from Cards WHERE id IN ("' + cardIds.join('","') + '")', [], function(tx, rs) {
                        let cards = {};
                        let cardsArr = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            let card = Utilities.prepareCardFromDb(rs.rows.item(i));
                            if (!card.strength) delete card.strength
                            if (!card.image) delete card.image;
                            cards[card.id] = card;
                        }
                        if (returnArray) {
                            for (let i = 0; i < cardIds.length; i++) {
                                const cardId = cardIds[i];
                                if (cards[cardId]) {
                                    cardsArr.push(cards[cardId]);
                                }
                            }
                        }
                        resolve(returnArray ? cardsArr : cards)
                    }, function(tx, error) { console.log(error); resolve({}) });
                });
            })

        }

    }

    static async searchCards(keyword, tags, limit) {

        // console.log("@@@@ searchCards", keyword, tags)

        if (window.useIndexedDb) {
            let sets = await window.db.sets.toArray();
            let allTags = await window.db.tags.toArray();
            let tagIndexes = await window.db.tagIndexes.toArray();
            let cards = await window.db.cards.filter(card => {
                if (card.customInt1 !== "") 
                    return false;

                let tagIds = tagIndexes.filter(ti => ti.cardId === card.id).map(ti => ti.tagId);
                let tagMatch = false;
                let keywordMatch = false;

                if (keyword) {
                    if (
                        (card.term && card.term.toLowerCase().indexOf(keyword) !== -1) ||
                        (card.definition && card.definition.toLowerCase().indexOf(keyword) !== -1) ||
                        (card.customText2 && card.customText2.toLowerCase().indexOf(keyword) !== -1)
                    ) {
                        keywordMatch = true;
                    }
                }
                
                if (tags.length !== 0) {
                    for (let i = 0; i < tags.length; i++) {
                        if (tagIds.indexOf(tags[i]) !== -1) {
                            tagMatch = true;
                            break
                        }
                    }
                }

                if (keyword && tags.length !== 0 && tagMatch && keywordMatch) {
                    return true;
                }

                if (keyword && tags.length === 0 && keywordMatch) {
                    return true;
                }

                if (!keyword && tags.length !== 0 && tagMatch) {
                    return true;
                }

                return false;
            }).toArray();

            return cards.map((card) => {
                card = Utilities.prepareCardFromDb(card);
                const set = sets.find(set => set.id === card.setId);
                if (set) {
                    card.setName = set.name;
                    card.setTerm = set.term;
                    card.setDefinition = set.definition;
                    return card;
                }
                return null;
            }).filter(card => card !== null);
        } else {

            return new Promise(async function(resolve, reject) {

                let tagsFilters = '';
                let keywordFilter = '';

                if (tags.length !== 0) {
                    tagsFilters = `
                    AND
                    (
                        Cards.id IN (
                            SELECT cardId
                            FROM TagIndexes
                            ${tags.map((tag, i) => {
                                return ((i === 0 ? " WHERE " : " OR ") + ("tagId LIKE '%" + tag + "%'"))
                            })}
                        )
                    )
                    `
                    tagsFilters = tagsFilters.replace(/,/g, '')
                }
                

                if (keyword) {
                    keywordFilter = `
                    AND
                    (
                        LOWER(Cards.term) LIKE "%${keyword}%" 
                        OR LOWER(Cards.definition) LIKE "%${keyword}%" 
                        OR LOWER(Cards.customText2) LIKE "%${keyword}%" 
                    )
                    `
                }

                window.db.transaction(function(tx) {
                    tx.executeSql(`
                        SELECT Cards.*, Sets.name as "setName", Sets.term as "setTerm", Sets.definition as "setDefinition"
                        FROM Cards 
                        INNER JOIN Sets
                        ON Cards.setId = Sets.id
                        WHERE 
                            (
                                CustomInt1 IS NULL
                            )
                            ${keywordFilter}
                            ${tagsFilters}
                        LIMIT ${(limit || 200)}
                    `, [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            let card = Utilities.prepareCardFromDb(rs.rows.item(i));
                            cards.push(card)
                        }
                        resolve(cards)
                    }, function(tx, error) { console.log(error); resolve([]) });
                });

            })

        }

    }

    static async getDueCards(reviewAfter) {

        // console.log("@@@@ getDueCards")

        if (window.useIndexedDb) {
            //TO DO  Need to sort
            let cards = await window.db.cards.where("reviewAfter").between(1, reviewAfter).limit(50).toArray();
            return cards.map(Utilities.prepareCardFromDb);
        } else {

            return new Promise(async function(resolve, reject) {

                //TO DO  Need to sort
                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Cards WHERE reviewAfter <> 0 AND reviewAfter < ' + reviewAfter + " AND CustomInt1 IS NULL LIMIT 50", [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            cards.push(Utilities.prepareCardFromDb(rs.rows.item(i)));
                        }
                        resolve(cards)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getNewCards() {

        // console.log("@@@@ getNewCards")
        
        if (window.useIndexedDb) {
            let cards = await window.db.cards.where("[reviewCount+strength]").between(
                [0, 0],
                [0, 4] 
              ).limit(50).toArray();
              return cards.map(Utilities.prepareCardFromDb);
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Cards WHERE reviewCount = 0 AND strength <> 5 AND CustomInt1 IS NULL LIMIT 50', [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            let card = Utilities.prepareCardFromDb(rs.rows.item(i));
                            cards.push(card)
                        }
                        resolve(cards)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getCardsByStregth(strength) {

        // console.log("@@@@ getCardsByStregth")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.where({customInt1: "", strength: strength}).limit(50).toArray()
            cards = cards.sort((a, b) => { return (a.lastReviewed - b.lastReviewed) })
            cards = cards.slice(0, 50);
            cards = cards.map(Utilities.prepareCardFromDb);
            return cards
        } else {

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Cards WHERE strength = ' + strength + ' AND CustomInt1 IS NULL ORDER BY lastReviewed ASC LIMIT 50', [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            let card = Utilities.prepareCardFromDb(rs.rows.item(i));
                            cards.push(card)
                        }
                        resolve(cards)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getDueCardsCount(reviewAfter) {

        // console.log("@@@@@ getDueCardsCount")

        if (window.useIndexedDb) {
            let count = await window.db.cards.where("reviewAfter").between(1, reviewAfter).count();
            return count
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT id FROM Cards WHERE CustomInt1 IS NULL AND reviewAfter <> 0 AND reviewAfter < ' + reviewAfter, [], function(tx, rs) {
                        resolve(rs.rows.length)
                    }, function(tx, error) { console.error(error); resolve(0) });
                });

            })

        }

    }

    static async getStrengthCardsCount() {

        // console.log("@@@@ getStrengthCardsCount")

        if (window.useIndexedDb) {

            let strengths = {
                '1': await window.db.cards.where({ strength: 1, customInt1: ""}).count() || 0,
                '3': await window.db.cards.where({ strength: 3, customInt1: ""}).count() || 0,
                '5': await window.db.cards.where({ strength: 5, customInt1: ""}).count() || 0,
            }

            return strengths;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT strength, count(id) as count FROM Cards WHERE CustomInt1 IS NULL AND (strength = 5 OR strength = 3 OR strength = 1) GROUP BY strength', [], function(tx, rs) {
                        // resolve(rs.rows.length)
                        let strengths = { '1': 0, '3': 0, '5': 0 }
                        for (var i = 0; i < rs.rows.length; i++) {
                            let card = rs.rows.item(i);
                            strengths[card.strength] = card.count
                        }
                        resolve(strengths)
                    }, function(tx, error) { console.error(error); resolve(0) });
                });

            })

        }

    }

    static async getNewCardsCount() {

        // console.log("@@@@ getNewCardsCount")

        if (window.useIndexedDb) {
            let count = await window.db.cards.where("[reviewCount+strength]").between(
                [0, 0],
                [0, 4] 
              ).count();

            // TO DO come up with a solution to these cards without set
            // const outliers = await window.db.cards.filter(item => setIds.indexOf(item.setId) === -1 && item.reviewCount === 0 && item.strength !== 5 && !item.deleted && item.customInt1 === "").toArray();
            // console.log("outliers", outliers)
            return count
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT id FROM Cards WHERE CustomInt1 IS NULL AND reviewCount = 0 AND strength <> 5 AND deleted IS NULL', [], function(tx, rs) {
                        resolve(rs.rows.length)
                    }, function(tx, error) { console.error(error); resolve(0) });
                });

            })

        }

    }

    static async getAllCardsGrouppedByLang() {

        // console.log("@@@@ getAllCardsGrouppedByLang")

        if (window.useIndexedDb) {

            let sets = await window.db.sets.toArray();
            let cards = await window.db.cards.where("customInt1").equals("").toArray();

            let cardsByLang = {}
            cards.map((card) => {
                const set = sets.find(set => set.id === card.setId);
                if (set) {
                    if (!cardsByLang[set.term]) {
                        cardsByLang[set.term] = [];
                    }
                    cardsByLang[set.term].push(card.term.toLowerCase() + "££" + card.id);
    
                    if (set.term !== set.definition) {
                        if (!cardsByLang[set.definition]) {
                            cardsByLang[set.definition] = [];
                        }
                        cardsByLang[set.definition].push(card.definition.toLowerCase() + "££" + card.id);
                    }
                }
                return card;
            });

            return cardsByLang;

        } else {

            if (!window.db) {
                return {}
            }

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql(`
                        SELECT Cards.term as "term", Cards.definition as "definition", Cards.id as "id", Sets.term as "termLang", Sets.definition as "definitionLang"
                        FROM Cards
                        INNER JOIN Sets
                        ON Cards.setId = Sets.id
                    `, [], function(tx, rs) {
                        let cardsByLang = {}
                        for (var i = 0; i < rs.rows.length; i++) {
                            let card = rs.rows.item(i);
                            if (!cardsByLang[card.termLang]) {
                                cardsByLang[card.termLang] = [];
                            }
                            cardsByLang[card.termLang].push(card.term.toLowerCase() + "££" + card.id);

                            if (card.termLang !== card.definitionLang) {
                                if (!cardsByLang[card.definitionLang]) {
                                    cardsByLang[card.definitionLang] = [];
                                }
                                cardsByLang[card.definitionLang].push(card.definition.toLowerCase() + "££" + card.id);
                            }
                        }
                        resolve(cardsByLang)
                    }, function(tx, error) { console.log(error); resolve([]) });
                });

            })

        }

    }

    static async getCards() {

        // console.log("@@@@ getCards")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.toArray()
            cards = cards.map(Utilities.prepareCardFromDb);
            return cards || []
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Cards', [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            cards.push(Utilities.prepareCardFromDb(rs.rows.item(i)))
                        }
                        resolve(cards)
                    }, function(tx, error) { console.log(error); resolve([]) });
                });

            })

        }

    }

    static async getCard(id) {

        // console.log("@@@@ getCard")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.where("id").equals(id).toArray()
            return cards.length !== 0 ? Utilities.prepareCardFromDb(cards[0]) : null;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Cards WHERE id="' + id + '"', [], function(tx, rs) {
                        if (rs.rows.length === 0) return resolve(null);
                        return resolve(rs.rows.item(0))
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getStudysetBySlug(slug) {

        // console.log("@@@@ getStudyset")

        if (window.useIndexedDb) {
            let sets = await window.db.sets.where("viewSecret").equals(slug).toArray();
            return sets.length !== 0 ? sets[0] : null;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Sets WHERE viewSecret="' + slug + '"', [], function(tx, rs) {
                        if (rs.rows.length === 0) return resolve(null)
                        resolve(rs.rows.item(0))
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getStudyset(id) {

        if (window.useIndexedDb) {
            let sets = await window.db.sets.where("id").equals(id).toArray();
            return sets.length !== 0 ? sets[0] : null;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Sets WHERE id="' + id + '"', [], function(tx, rs) {
                        if (rs.rows.length === 0) return resolve(null)
                        resolve(rs.rows.item(0))
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getStudysets() {

        // console.log("@@@@ getStudysets")

        if (window.useIndexedDb) {
            let sets = await window.db.sets.toArray();
            for (let i = 0; i < sets.length; i++) {
                sets[i].cardNo = await window.db.cards.where({
                    setId: sets[i].id,
                    customInt1: ""
                }).count() || 0;   
            }
            sets = sets.sort((a, b) => { return (new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()) }).reverse();
            return sets || [];
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql(`
                        SELECT Sets.id, Sets."createdAt", Sets."updatedAt", Sets.name, Sets.term, Sets.definition, Count(Cards.id) AS cardNo 
                        FROM Sets 
                        LEFT JOIN 
                        Cards ON Sets.id = Cards.setId
                        WHERE Cards.CustomInt1 IS NULL
                        GROUP BY Sets.id 
                        ORDER BY Sets.createdAt DESC
                    `, [], function(tx, rs) {
                        let sets = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            sets.push(rs.rows.item(i))
                        }
                        resolve(sets)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getTagReferencesGrouppedByTag() {

        // console.log("@@@@ getTagReferencesGrouppedByTag")

        if (window.useIndexedDb) {
            const tags = await window.db.tags.toArray();

            const tagIndexes = await window.db.tagIndexes.toArray();
            
            let tagReferences = [];
            for (let j = 0; j < tags.length; j++) {
                const tag = tags[j];
                const count = tagIndexes.filter(tagIndex => tagIndex.tagId === tag.id).length;
                if (count !== 0)
                    tagReferences.push({
                        tagId: tag.id,
                        tagName: tag.name,
                        tagColor: tag.color,
                        count: count
                    })
            }

            return tagReferences;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT TagIndexes.tagId as tagId, Tags.name as tagName, Tags.color as tagColor, count(TagIndexes.cardId) as count FROM TagIndexes INNER JOIN Tags ON Tags.id = TagIndexes.tagId GROUP BY tagId ORDER BY Tags.createdAt', [], function(tx, rs) {
                        let sets = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            sets.push(rs.rows.item(i))
                        }
                        resolve(sets)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getTagReferencesBySet(id, getArchived) {

        // console.log("@@@@ getTagReferencesBySet " + id + " " + getArchived)

        if (window.useIndexedDb) {
            const tags = await window.db.tags.toArray();
            const sets = getArchived ? await window.db.sets.toArray() : await window.db.sets.where("id").equals(id).toArray();
            const tagIndexes = await window.db.tagIndexes.toArray();
            const archivedCards = await window.db.cards.where("customInt1").notEqual("").toArray();
            const archivedCardIds = archivedCards.map(c => c.id);
            
            let tagReferences = [];

            if (getArchived) {
                for (let j = 0; j < tags.length; j++) {
                    const tag = tags[j];
                    const tiS = tagIndexes.filter(tagIndex => tagIndex.tagId === tag.id);

                    let count = 0;
                    for (let k = 0; k < tiS.length; k++) {
                        const ti = tiS[k];
                        if (archivedCardIds.indexOf(ti.cardId) !== -1) {
                            count++
                        }
                    }
                    
                    if (count !== 0) {
                        tagReferences.push({
                            setId: "null",
                            tagId: tag.id,
                            tagName: tag.name,
                            tagColor: tag.color,
                            count: count
                        })
                    }
                }
            } else {
                for (let i = 0; i < sets.length; i++) {
                    const set = sets[i];
                    for (let j = 0; j < tags.length; j++) {
                        const tag = tags[j];
                        const tiS = tagIndexes.filter(tagIndex => tagIndex.tagId === tag.id && tagIndex.setId === set.id);
    
                        let count = 0;
                        for (let k = 0; k < tiS.length; k++) {
                            const ti = tiS[k];
                            if (archivedCardIds.indexOf(ti.cardId) === -1) {
                                count++
                            }
                        }
                        
                        if (count !== 0) {
                            tagReferences.push({
                                setId: set.id,
                                tagId: tag.id,
                                tagName: tag.name,
                                tagColor: tag.color,
                                count: count
                            })
                        }
                    }
                }
            }

            return tagReferences;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql(`
                        SELECT TagIndexes.setId AS setId, TagIndexes.tagId as tagId, Tags.name as tagName, Tags.color as tagColor, count(TagIndexes.cardId) as count 
                        FROM TagIndexes INNER JOIN Tags ON Tags.id = TagIndexes.tagId 
                        ${ (!getArchived) ? `
                        WHERE
                            TagIndexes.cardId NOT IN (
                                SELECT id
                                FROM Cards
                                WHERE CustomInt1 IS NOT NULL
                            )
                        AND
                            TagIndexes.setId="${id}" 
                        ` : `
                        WHERE
                            TagIndexes.cardId IN (
                                SELECT id
                                FROM Cards
                                WHERE CustomInt1 IS NOT NULL
                            )
                        ` }
                        GROUP BY setId, tagId 
                        ORDER BY Tags.createdAt
                    `, [], function(tx, rs) {
                        let sets = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            sets.push(rs.rows.item(i))
                        }
                        resolve(sets)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getTagReferences(preloadedSets, preloadedTags) {

        // console.log("@@@@ getTagReferences")
        // tO do might return archived ones!!

        if (window.useIndexedDb) {
            const tags = preloadedTags || (await window.db.tags.toArray());
            const sets = preloadedSets || (await window.db.sets.toArray());

            // var startTime = (new Date()).getTime();

            const tagIndexes = await window.db.tagIndexes.toArray();

            // var endTime = (new Date()).getTime();
            // console.log("@@@@@ PERFORMENCE :" + (endTime-startTime));
            
            let tagReferences = [];

            for (let i = 0; i < sets.length; i++) {
                const set = sets[i];
                for (let j = 0; j < tags.length; j++) {
                    const tag = tags[j];
                    const count = tagIndexes.filter(tagIndex => tagIndex.tagId === tag.id && tagIndex.setId === set.id).length;
                    if (count !== 0)
                        tagReferences.push({
                            setId: set.id,
                            tagId: tag.id,
                            tagName: tag.name,
                            tagColor: tag.color,
                            count: count
                        })
                }
            }

            return tagReferences;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql(`
                        SELECT TagIndexes.setId AS setId, TagIndexes.tagId as tagId, Tags.name as tagName, Tags.color as tagColor, count(TagIndexes.cardId) as count 
                        FROM TagIndexes 
                        INNER JOIN Tags ON Tags.id = TagIndexes.tagId 
                        WHERE TagIndexes.cardId NOT IN (
                            SELECT id
                            FROM Cards
                            WHERE CustomInt1 IS NOT NULL
                        )
                        GROUP BY setId, tagId 
                        ORDER BY Tags.createdAt
                    `, [], function(tx, rs) {
                        let sets = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            sets.push(rs.rows.item(i))
                        }
                        console.log(sets)
                        resolve(sets)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })
        
        }

    }

    static async saveSetting(key, value) {

        // console.log("@@@@ saveSetting")

        if (window.useIndexedDb) {
            await window.db.settingss.put({
                key: key,
                value: value
            })
        } else {

            if (typeof value === "object") {
                value = JSON.stringify(value);
            }

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql(`DELETE FROM Settings WHERE key="${key}"`);
                    tx.executeSql(`INSERT INTO Settings (key, value) VALUES ('${key}', '${value}')`);
                }, function(error) { console.log(error); resolve() }, function() { resolve(); });
            })

        }

    }

    static async getCardPairTypes() {

        // console.log("@@@@ getCardPairTypes")

        if (window.useIndexedDb) {
            let allTypesObj = {}
            let allTypes = [];

            const sets = await window.db.sets.toArray();

            for (let i = 0; i < sets.length; i++) {
                if ((!(allTypesObj[sets[i].term + "£££" + sets[i].definition])) && sets[i].definition && sets[i].term) {
                    allTypesObj[sets[i].term + "£££" + sets[i].definition] = 0;
                }
            }

            const cards = await window.db.cards.toArray();

            for (let i = 0; i < cards.length; i++) {
                const card = cards[i];
                const set = sets.find(set => set.id === card.setId);
                if (set && set.term && set.definition) {
                    allTypesObj[set.term + "£££" + set.definition]++;
                }
            }
            
            for (let lang in allTypesObj) {
                allTypes.push({
                    name: lang,
                    count: allTypesObj[lang]
                })
            }

            allTypes = allTypes.sort((a, b) => { return (a.count - b.count) }).reverse();

            return allTypes
        } else {

            return new Promise(async function(resolve, reject) {

                let terms = await new Promise(function(innerResolve, innerReject) {
                    window.db.transaction(function(tx) {
                        tx.executeSql('SELECT Sets.term || "£££" || Sets.definition as language, Count(Cards.id) as total FROM Sets INNER JOIN Cards ON Sets.id = Cards.setId WHERE Sets.term IS NOT NULL AND Sets.term <> "" AND Sets.definition IS NOT NULL AND Sets.definition <> "" GROUP BY language', [], function(tx, rs) {
                            let sets = [];
                            for (var i = 0; i < rs.rows.length; i++) {
                                sets.push(rs.rows.item(i))
                            }
                            innerResolve(sets)
                        }, function(tx, error) { console.error(error); innerResolve([]) });
                    });
                })

                let totals = {};

                for (let i = 0; i < terms.length; i++) {
                    let langauge = terms[i].language
                    if (!totals[langauge])
                        totals[langauge] = 0;
                    totals[langauge] += terms[i].total;
                }

                let totalsArr = [];

                for (let key in totals) {
                    totalsArr.push({
                        name: key,
                        count: totals[key]
                    })
                }

                totalsArr.sort((a, b) => { return (a.count - b.count) }).reverse();

                resolve(totalsArr)

            })

        }

    }

    static async getCardTypes() {

        // console.log("@@@@ getCardTypes")

        if (window.useIndexedDb) {
            let allTypesObj = {}
            let allTypes = [];

            const sets = await window.db.sets.toArray();

            for (let i = 0; i < sets.length; i++) {
                if (sets[i].term && !allTypesObj[sets[i].term]) {
                    allTypesObj[sets[i].term] = 0;
                }
                if (sets[i].definition && !allTypesObj[sets[i].definition]) {
                    allTypesObj[sets[i].definition] = 0;
                }
            }

            const cards = await window.db.cards.toArray();

            for (let i = 0; i < cards.length; i++) {
                const card = cards[i];
                const set = sets.find(set => set.id === card.setId);
                if (set) {
                    if (set.term) {
                        allTypesObj[set.term]++;
                    }
                    if (set.definition) {
                        allTypesObj[set.definition]++;
                    }
                }
            }
            
            for (let lang in allTypesObj) {
                allTypes.push({
                    name: lang,
                    count: allTypesObj[lang]
                })
            }

            allTypes = allTypes.sort((a, b) => { return (a.count - b.count) }).reverse();

            return allTypes
        } else {

            return new Promise(async function(resolve, reject) {

                let terms = await new Promise(function(innerResolve, innerReject) {
                    window.db.transaction(function(tx) {
                        tx.executeSql('SELECT Sets.term as language, Count(Cards.id) as total FROM Sets INNER JOIN Cards ON Sets.id = Cards.setId WHERE Sets.term IS NOT NULL AND Sets.term <> "" GROUP BY Sets.term', [], function(tx, rs) {
                            let sets = [];
                            for (var i = 0; i < rs.rows.length; i++) {
                                sets.push(rs.rows.item(i))
                            }
                            innerResolve(sets)
                        }, function(tx, error) { console.error(error); innerResolve([]) });
                    });
                })

                let definitions = await new Promise(function(innerResolve, innerReject) {
                    window.db.transaction(function(tx) {
                        tx.executeSql('SELECT Sets.definition as language, Count(Cards.id) as total FROM Sets INNER JOIN Cards ON Sets.id = Cards.setId WHERE Sets.definition IS NOT NULL AND Sets.term <> "" GROUP BY Sets.definition', [], function(tx, rs) {
                            let sets = [];
                            for (var i = 0; i < rs.rows.length; i++) {
                                sets.push(rs.rows.item(i))
                            }
                            innerResolve(sets)
                        }, function(tx, error) { console.error(error); innerResolve([]) });
                    });
                })

                let totals = {};

                for (let i = 0; i < terms.length; i++) {
                    let langauge = terms[i].language
                    if (!totals[langauge])
                        totals[langauge] = 0;
                    totals[langauge] += terms[i].total;
                }

                for (let i = 0; i < definitions.length; i++) {
                    let langauge = definitions[i].language
                    if (!totals[langauge])
                        totals[langauge] = 0;
                    totals[langauge] += definitions[i].total;
                }

                let totalsArr = [];

                for (let key in totals) {
                    totalsArr.push({
                        name: key,
                        count: totals[key]
                    })
                }

                totalsArr.sort((a, b) => { return (a.count - b.count) }).reverse();

                resolve(totalsArr)

            })

        }

    }

    static async getTag(id) {

        // console.log("@@@@ getTag")

        if (window.useIndexedDb) {
            let tags = await window.db.tags.where("id").equals(id).toArray()
            return tags.length !== 0 ? tags[0] : null;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Tags WHERE id="' + id + '"', [], function(tx, rs) {
                        if (rs.rows.length === 0) return resolve(null);
                        return resolve(rs.rows.item(0))
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getSetting(key) {

        // console.log("@@@@ getSetting")
        
        if (window.useIndexedDb) {
            let setting = await window.db.settingss.where("key").equals(key).toArray();
            return setting.length !== 0 ? setting[0].value : null;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT value FROM Settings WHERE key="' + key + '"', [], function(tx, rs) {
                        if (rs.rows.length > 0) resolve(rs.rows.item(0).value);
                        else resolve(null)
                    }, function(tx, error) { console.error(error); resolve(null) });
                });

            })

        }

    }

    static async getSettingsObj() {

        // console.log("@@@@ getSettingsObj")

        if (window.useIndexedDb) {
            let settings = await window.db.settingss.toArray();
            let settingsObj = {};
            for (let i = 0; i < settings.length; i++) {
                settingsObj[settings[i].key] = settings[i].value
            }
            return settingsObj;
        } else {
            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Settings', [], function(tx, rs) {
                        let tags = {};
                        for (var i = 0; i < rs.rows.length; i++) {
                            const def = rs.rows.item(i)
                            tags[def.key] = def.value;
                        }
                        resolve(tags)
                    }, function(tx, error) { 
                        console.error(error);
                        resolve({}) 
                    });
                });
    
            })
        }

    }

    static async getSettings() {

        // console.log("@@@@ getSettings")

        if (window.useIndexedDb) {
            let settings = await window.db.settingss.toArray();
            return settings;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Settings', [], function(tx, rs) {
                        let tags = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            tags.push(rs.rows.item(i))
                        }
                        resolve(tags)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getTags() {

        // console.log("@@@@ getTags")

        if (window.useIndexedDb) {
            let tags = await window.db.tags.toArray();
            return tags || [];
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT * FROM Tags', [], function(tx, rs) {
                        let tags = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            tags.push(rs.rows.item(i))
                        }
                        resolve(tags)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getStudysetCount() {

        // console.log("@@@@ getStudysetCount")

        if (window.useIndexedDb) {
            const count = await window.db.sets.count();
            return count || 0;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT Count(rowid) AS count FROM Sets', [], function(tx, rs) {
                        if (rs.rows.length === 0) return resolve(0);
                        return resolve(rs.rows.item(0).count)
                    }, function(tx, error) {
                        console.error(error); 
                        localStorage.setItem("preventAppOpenTrack", "true")
                        window.location.reload();
                        resolve(0) 
                    });
                });

            })

        }

    }

    static async getCardCount() {

        // console.log("@@@@ getCardCount")

        if (window.useIndexedDb) {
            const count = await window.db.cards.count();
            return count;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT Count(rowid) AS count FROM Cards', [], function(tx, rs) {
                        if (rs.rows.length === 0) return resolve(0);
                        return resolve(rs.rows.item(0).count)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });

            })

        }

    }

    static async getTagCount() {

        // console.log("@@@@ getTagCount")

        if (window.useIndexedDb) {
            const count = await window.db.tags.count();
            return count;
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT Count(rowid) AS count FROM Tags', [], function(tx, rs) {
                        if (rs.rows.length === 0) return resolve(0);
                        return resolve(rs.rows.item(0).count-2)
                    }, function(tx, error) { console.error(error); resolve(0) });
                });

            })

        }

    }

    static async getCardsWithFields(fields) {

        // console.log("@@@@ getCardsWithFields")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.toArray()
            cards = cards.map(Utilities.prepareCardFromDb);
            return cards || []
        } else {

            return new Promise(async function(resolve, reject) {

                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT ' + (fields || "*") + ' FROM Cards', [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            let card = Utilities.prepareCardFromDb(rs.rows.item(i));
                            cards.push(card)
                        }
                        resolve(cards)
                    }, function(tx, error) { console.log(error); resolve([]) });
                });

            })

        }

    }

    static async getCardsCountWithImages() {

        // console.log("@@@@ getCardsCountWithImages")

        if (window.useIndexedDb) {
            let count = await window.db.cards.where("image").notEqual("").count()
            return count;
        } else {

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT count(id) as "count" from Cards WHERE image <> ""', [], function(tx, rs) {
                        resolve(rs.rows.length !== 0 ? rs.rows.item(0).count : 0 )
                    }, function(tx, error) { console.error(error); resolve(0) });
                });
            })

        }

    }

    static async getCardsCountWithLinks() {

        // console.log("@@@@ getCardsCountWithLinks")

        if (window.useIndexedDb) {
            let count = await window.db.cards.where("links").notEqual("").count()
            return count;
        } else {

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT count(id) as "count" from Cards WHERE links <> ""', [], function(tx, rs) {
                        resolve(rs.rows.length !== 0 ? rs.rows.item(0).count : 0 )
                    }, function(tx, error) { console.error(error); resolve(0) });
                });
            })

        }

    }

    static async getCardsCountWithCustomFields() {

        // console.log("@@@@ getCardsCountWithCustomFields")

        if (window.useIndexedDb) {
            let count = await window.db.cards.where("customText2").notEqual("").count()
            return count;
        } else {

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql('SELECT count(id) as "count" from Cards WHERE customText2 <> ""', [], function(tx, rs) {
                        resolve(rs.rows.length !== 0 ? rs.rows.item(0).count : 0 )
                    }, function(tx, error) { console.error(error); resolve(0) });
                });
            })

        }

    }

    static async getTotalReviewsCount() {

        // console.log("@@@@ getTotalReviewsCount")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.where("reviewCount").notEqual(0).toArray();
            let count = 0;
            for (let i = 0; i < cards.length; i++) {
                count += cards[i].reviewCount;
            }
            return count;
        } else {

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql(`SELECT Sum(ReviewCount) as "count" from Cards`, [], function(tx, rs) {
                        resolve(rs.rows.length ? rs.rows.item(0).count : 0)
                    }, function(tx, error) { console.error(error); resolve(0) });
                });
            })
        
        }

    }

    static async destroy() {

        if (window.useIndexedDb) {
            await window.db.sets.clear();
            await window.db.settingss.clear();
            await window.db.tags.clear();
            await window.db.batchContent.clear();
            const res = await window.db.tagIndexes.clear();
            return res;
        } else {
            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql(`DELETE FROM Cards`);
                    tx.executeSql(`DELETE FROM Tags`);
                    tx.executeSql(`DELETE FROM Sets`);
                    tx.executeSql(`DELETE FROM Settings`);
                    tx.executeSql(`DELETE FROM TagIndexes`);
                    tx.executeSql(`DELETE FROM BatchContent`);
                }, function(error) { console.log(error); resolve() }, function() { resolve(); });
            })
        }

    }

    static async fullImport(data) {

        if (!data.Cards || !data.Tags || !data.Settings || !data.Sets) {
            throw Error ("Missing Entity");
        }

        data.Cards = data.Cards.map(Utilities.prepareCardForImport);

        let res = await SQLStorageImported.destroy();

        for (let i = 0; i < data.Tags.length; i++) {
            const tagRes = await SQLStorageImported.saveTag(data.Tags[i]);
        }

        for (let i = 0; i < data.Sets.length; i++) {
            const setRes = await SQLStorageImported.saveSet(data.Sets[i]);
        }

        for (let i = 0; i < data.Settings.length; i++) {
            const tagRes = await SQLStorageImported.saveSetting(data.Settings[i].key, data.Settings[i].value)
        }

        const cardRes = await SQLStorageImported.saveCard(data.Cards, true, true);
    
    }

    static async fullExport() {

        if (window.useIndexedDb) {

            const cards = await window.db.cards.toArray();
            const sets = await window.db.sets.toArray();
            const settings = await window.db.settingss.toArray();
            const tags = await window.db.tags.toArray();
      
            let tables = {
                "Cards": cards,
                "Sets": sets,
                "Settings": settings,
                "Tags": tags
            }

            tables.Cards = tables.Cards.map(Utilities.prepareCardFromDb);
            tables.Cards = tables.Cards.map(Utilities.prepareCardForExport);
            tables.Tags = tables.Tags.map(Utilities.prepareTagForExport);
            tables.Sets = tables.Sets.map(Utilities.prepareSetForExport);
            tables.Settings = tables.Settings.map(Utilities.prepareSettingForExport).filter(setting => setting);

            return tables

        } else {
            let tables = {
                "Cards": null,
                "Sets": null,
                "Settings": null,
                "Tags": null
            }

            for (let table in tables) {
                tables[table] = await new Promise((resolve, reject) => {
                    window.db.transaction(function(tx) { tx.executeSql('SELECT * FROM ' + table, [], function(tx, rs) {
                            let data = []; for (let i = 0; i < rs.rows.length; i++) { data.push(rs.rows.item(i)); }; resolve(data);
                    }, function(tx, error) { console.log(error); resolve(null) }); });
                })
            }

            tables.Cards = tables.Cards.map(Utilities.prepareCardFromDb);
            tables.Cards = tables.Cards.map(Utilities.prepareCardForExport);
            tables.Tags = tables.Tags.map(Utilities.prepareTagForExport);
            tables.Sets = tables.Sets.map(Utilities.prepareSetForExport);
            tables.Settings = tables.Settings.map(Utilities.prepareSettingForExport).filter(setting => setting);

            return tables
        }

    }

    static async getActivityCountGrouppedByDay() {

        // console.log("@@@@ getActivityCountGrouppedByDay")

        if (window.useIndexedDb) {
            let cards = await window.db.cards.toArray();
            let dayActivityCount = {};
            let dayActivityCountArr = [];
            
            for (let i = 0; i < cards.length; i++) {
                const card = cards[i];
                const updatedAt = Utilities.formatDate(card.updatedAt, "YYYY-MM-DD");
                const createdAt = Utilities.formatDate(card.createdAt, "YYYY-MM-DD");

                if (!dayActivityCount[updatedAt]) {
                    dayActivityCount[updatedAt] = 0;
                }
                dayActivityCount[updatedAt]++;

                if (createdAt !== updatedAt) {
                    if (!dayActivityCount[createdAt]) {
                        dayActivityCount[createdAt] = 0;
                    }
                    dayActivityCount[createdAt]++;                    
                }
            }

            for (let day in dayActivityCount) {
                dayActivityCountArr.push({
                    DateHash: day,
                    ActivityCount: dayActivityCount[day],
                    ts: new Date(day).getTime()
                })
            }

            // TO DO issue, seems like when full sync, the last day has everything as active - probs because last updated is set, is this ok?
            dayActivityCountArr = dayActivityCountArr.sort((a, b) => { return (a.ts - b.ts) }).reverse();

            return dayActivityCountArr;
        } else {

            return new Promise(async function(resolve, reject) {
                window.db.transaction(function(tx) {
                    tx.executeSql(`SELECT DateHash as "DateHash", SUM(Count) as "ActivityCount" FROM ( SELECT strftime("%Y-%m-%d", CreatedAt) as "DateHash", Count(id) as Count From Cards GROUP BY strftime("%Y-%m-%d", CreatedAt) UNION SELECT strftime("%Y-%m-%d", UpdatedAt) as "DateHash", Count(id) as Count From Cards GROUP BY strftime("%Y-%m-%d", UpdatedAt) ) GROUP BY DateHash`, [], function(tx, rs) {
                        let cards = [];
                        for (var i = 0; i < rs.rows.length; i++) {
                            cards.push(rs.rows.item(i))
                        }
                        resolve(cards)
                    }, function(tx, error) { console.error(error); resolve([]) });
                });
            })

        }
    }

}

export default SQLStorage;
